module.exports = __webpack_public_path__ + "img/flask-round-poison.295366e6.svg";